import { dbDataStore, messageAndErrorStore, projectStore, userStore } from "../../store/Store";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

// images and style
import Close from "../../assets/close.svg";

export default function ArchiveProject({ setTrigger, statusUpdate }) {
  // global
  const currentProject = projectStore((data) => data.currentProject);
  const JwtToken = userStore((data) => data.JwtToken);
  const currentUser = userStore((data) => data.currentUser);
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const setProjectData = dbDataStore((data) => data.setProjectData);
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  // local
  const [pending, setPending] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setPending(true);
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);

    const reqBody = currentProject.project;
    reqBody.updated_by_id = currentUser.id;
    if (statusUpdate === "Archive") {
      reqBody.archived = true;
    } else {
      reqBody.archived = false;
    }

    const requestOptions = {
      method: "PATCH",
      headers,
      body: JSON.stringify(reqBody),
      signal: controller.signal,
    };

    fetch(
      `${process.env.REACT_APP_BACKEND}/pc/project/${currentProject.project.id}`,
      requestOptions
    )
      .then((res) => {
        if (!res.ok) {
          if (res.status === 401) {
            setAuthStatus(false);
            navigate("/login");
          } else {
            setPending(false);
            toggleNewMessage("Could not update project");
            return;
          }
        } else {
          return res.json();
        }
      })
      .then((data) => {
        console.log(data.data);
        setProjectData(data.data.all_projects);
        navigate("/");
      })
      .catch((err) => {
        toggleNewMessage("Could not update projrect");
        setPending(false);
        return;
      })
      .finally(() => setPending(false));
    return () => controller.abort();
  };

  return (
    <div className="popup">
      <div className="popup-inner-add-company">
        {!pending && (
          <img src={Close} onClick={() => setTrigger(false)} alt="close" />
        )}
        {currentProject && (
          <p>
            Are you sure you want to {statusUpdate}{" "}
            {currentProject.project.job_name}?
          </p>
        )}
        {!pending && (
          <button className="delete-btn" onClick={handleClick}>
            Yes
          </button>
        )}
        {!pending && (
          <button className="propx-btn" onClick={() => setTrigger(false)}>
            No
          </button>
        )}
        {pending && (
          <button
            className="btn btn-secondary"
            style={{ margin: "20px 20px 20px 0" }}
            disabled
          >
            Submitting...
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
        )}
      </div>
    </div>
  );
}
